<div class="field">
  <label for="year-input">Model year</label>
  <div class="input-wrap">
    <input
      #yearInput
      id="year-input"
      type="number"
      [formControl]="control()"
      [min]="yearRange.min"
      [max]="yearRange.max"
      placeholder="e.g. 2015" />
    @if (control().value !== null && control().enabled) {
      <button
        type="button"
        class="clear-button"
        aria-label="Clear model year"
        title="Clear"
        (click)="clear()">
        &times;
      </button>
    }
  </div>
  @if (control().invalid && control().touched) {
    <p class="field-error">Enter a year between {{ yearRange.min }} and {{ yearRange.max }}.</p>
  }
</div>
